module.exports = __webpack_public_path__ + "media/images/icons/twotone/filter-22a67e89708e5099b7de0ad5438dfc80.svg";